const NavigationTokens = {
    AboutUs: "AboutUs",
    AccountStatement: "AccountStatement",
    AddressAssignment: "AddressAssignment",
    AddressExpenseAllocation: "AddressExpenseAllocation",
    AddressExpenseAllocationInfo: "AddressExpenseAllocationInfo",
    AdobeReader: "adobeReader",
    ApplyExpenseAllocations: "ApplyExpenseAllocations",
    ApprovalResults: "ApprovalResults",
    Article: "Article",
    AssignBilling: "AssignBilling",
    AssignCheckoutReview: "AssignCheckoutReview",
    AssignExpenseAllocation: "AssignExpenseAllocation",
    AssignShippingAddress: "AssignShippingAddress",
    Availability: "Availability",
    BillingAddress: "BillingAddress",
    BrowserNotCompatible: "BrowserNotCompatible",
    Budgets: "Budgets",
    BusinessRedirect: "BusinessRedirect",
    CardSecurityCode: "CardSecurityCode",
    Careers: "Careers",
    CartPopup: "CartPopup",
    CartUpdate: "CartUpdate",
    Category: "Category",
    CategoryListEdit: "CategoryListEdit",
    CategoryOfSalesReport: "CategoryOfSalesReport",
    ChangeCartAddress: "ChangeCartAddress",
    ChangePassword: "ChangePassword",
    ChangePasswordReq: "ChangePasswordReq",
    CheckCrossDomainCookie: "CheckCrossDomainCookie",
    CheckOut: "CheckOut",
    ClearCookiesToZip: "ClearCookiesToZip",
    Coffee: "Coffee",
    CompletingYourOrder: "CompletingYourOrder",
    ContactUs: "ContactUs",
    CostContainmentReport: "CostContainmentReport",
    CreateAnOrder: "CreateAnOrder",
    CreateaShoppingList: "CreateaShoppingList",
    CrossDomainCookieLogin: "CrossDomainCookieLogin",
    CustomerService: "CustomerService",
    CustomItem: "CustomItem",
    CustomItemReturn: "CustomItemReturn",
    CustomPrint: "CustomPrint",
    CustomProducts: "CustomProducts",
    CustomSolutions: "CustomSolutions",
    Dashboard: "Dashboard",
    Departments: "Departments",
    DiverseVendorReport: "DiverseVendorReport",
    DynamicPage: "DynamicPage",
    EditExpenseAllocation: "EditExpenseAllocation",
    EditShippingAddress: "EditShippingAddress",
    Error: "Error",
    FAQs: "FAQs",
    FindaProduct: "FindaProduct",
    ForgotPassword: "ForgotPassword",
    GroupUserSettings: "GroupUserSettings",
    HelpPage: "HelpPage",
    HelpPDF: "HelpPDF",
    Home: "Home",
    InvoiceHistory: "InvoiceHistory",
    InvoiceHistoryDetails: "InvoiceHistoryDetails",
    InvoicePreferences: "InvoicePreferences",
    InkToner: "InkToner",
    InkTonerFinder: "InkTonerFinder",
    InkTonerModels: "InkTonerModels",
    InkTonerAllBrands: "InkTonerAllBrands",
    InkTonerResults: "InkTonerResults",
    ItemFinderMain: "ItemFinderMain",
    ItemFinderDetails: "ItemFinderDetails",
    ItemType: "ItemType",
    LandingPage: "LandingPage",
    Login: "Login",
    Logout: "Logout",
    LowCostAlternativeReport: "LowCostAlternativeReport",
    ManageAddresses: "ManageAddresses",
    ManageCreditCards: "ManageCreditCards",
    ManageCheckingAccounts: "ManageCheckingAccounts",
    ManageDeliveryPoints: "ManageDeliveryPoints",
    ManageExpenseAllocations: "ManageExpenseAllocations",
    ManageGroupSettings: "ManageGroupSettings",
    ManageGroups: "ManageGroups",
    ManageOrderApproval: "ManageOrderApproval",
    ManageUsers: "ManageUsers",
    ManageUserEdit: "ManageUserEdit",
    MyAccount: "MyAccount",
    MyListDetails: "MyListDetails",
    MyListDetailsEmpty: "MyListDetailsEmpty",
    MyLists: "MyLists",
    MyPreferredItems: "MyPreferredItems",
    MyProofs: "MyProofs",
    NewShippingAddress: "NewShippingAddress",
    NoResults: "NoResults",
    OfficeInteriors: "OfficeInteriors",
    OfficeServices: "OfficeServices",
    OINewContact: "OINewContact",
    OISignup: "OISignup",
    OISubmit: "OISubmit",
    OnlineStatement: "OnlineStatement",
    OldSiteHome: "OldSiteHome",
    OldSiteRegister: "OldSiteRegister",
    OldSiteLogin: "OldSiteLogin",
    OnlineSecurity: "OnlineSecurity",
    OrderApproval: "OrderApproval",
    OrderConfirmation: "OrderConfirmation",
    OrderFillRateReport: "OrderFillRateReport",
    OrderHistory: "OrderHistory",
    OrderHistoryDetails: "OrderHistoryDetails",
    OrderListExpenseAllocation: "OrderListExpenseAllocation",
    OrderListUser: "OrderListUser",
    OrdersAwaitingApproval: "OrdersAwaitingApproval",
    OrderAwaitingApprovalDetails: "OrderAwaitingApprovalDetails",
    OrderListShippingAddress: "OrderListShippingAddress",
    OrderTotalsExpenseAllocation: "OrderTotalsExpenseAllocation",
    OrderTotalsShippingAddress: "OrderTotalsShippingAddress",
    OutForDelivery: "OutForDelivery",
    Payment: "Payment",
    PaymentMethods: "PaymentMethods",
    PaymentProcessed: "PaymentProcessed",
    PoliciesAndHelp: "PoliciesAndHelp",
    PopupDynamic: "PopupDynamic",
    PopupPage: "PopupPage",
    PrivacyPolicy: "PrivacyPolicy",
    ProductCompare: "ProductCompare",
    ProductDetail: "ProductDetail",
    ProductDetails: "ProductDetails",
    ProductList: "ProductList",
    Punchout: "Punchout",
    QuickOrder: "QuickOrder",
    ReadCookie: "ReadCookie",
    RecentMyListDetails: "RecentMyListDetails",
    MyWBRecentItems: "MyWBRecentItems",
    Register: "Register",
    RegisterLogin: "RegisterLogin",
    RegAccountNumber: "RegAccountNumber",
    RegComplete: "RegComplete",
    RegInstantRegistration: "RegInstantRegistration",
    RegUserRegistration: "RegUserRegistration",
    RegZipCode: "RegZipCode",
    ReorderRegistration: "ReorderRegistration",
    ReorderMaintenance: "ReorderMaintenance",
    Reports: "Reports",
    ReportRender: "ReportRender",
    Return: "Return",
    ReturnCenter: "ReturnCenter",
    ReturnDetails: "ReturnDetails",
    ReturnPopup: "ReturnPopup",
    ReturnsPolicy: "ReturnsPolicy",
    ReturnsReport: "ReturnsReport",
    SafetyDataSheets: "SafetyDataSheets",
    SafetyDataSheetsPdfViewer: "SafetyDataSheetPdfViewer",
    SalesTax: "SalesTax",
    SameDay: "SameDay",
    SaveCardInfo: "SaveCardInfo",
    SavedCartDetails: "SavedCartDetails",
    SavedCarts: "SavedCarts",
    SavedReports: "SavedReports",
    SearchResults: "SearchResults",
    SelectAccount: "SelectAccount",
    SelectExpenseAllocations: "SelectExpenseAllocations",
    SetPassword: "SetPassword",
    ShippingAddress: "ShippingAddress",
    ShippingInformation: "ShippingInformation",
    ShoppingCart: "ShoppingCart",
    SilentLogin: "SilentLogin",
    Special: "Special",
    SpecificResults: "SpecificResults",
    StatementHowTo: "StatementHowTo",
    SubmitOrder: "SubmitOrder",
    SustainabilityReport: "SustainabilityReport",
    TermsOfUse: "TermsOfUse",
    TotalAvgPercentSavingsReport: "TotalAvgPercentSavingsReport",
    UserSettings: "UserSettings",
    UsageExpenseAllocation: "UsageExpenseAllocation",
    UsageShippingAddress: "UsageShippingAddress",
    UserExpenseAllocation: "UserExpenseAllocation",
    UserListing: "UserListing",
    ViewCheckoutValues: "ViewCheckoutValues",
    WBGovSolutions: "WBGovSolutions",
    WBGSA: "WBGSA",
    WebAccessibility: "WebAccessibility",
    Web2PrintProducts: "Web2PrintProducts",
    Web2PrintProofs: "Web2PrintProofs",
    WebForm2: "WebForm2",
    WebForm3: "WebForm3",
    WebUserSetup: "WebUserSetup",
    WhattaBargain: "WhattaBargain"
};
export default NavigationTokens;